import EntranceRegisterForm from './EntranceRegisterForm';

export default function EntranceRegisterPage() {
  return  <>
     <EntranceRegisterForm />;
  </>
}

